import React from 'react';
import { Link } from 'react-router-dom';

const PlanSection = () => {
    return (
        <>
            <section className="price__area pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="section__title section__title-3 text-center mb-55">
                                <h2>Select a Virtual Office that aligns with your requirements</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="price__item p-relative transition-3 fix mb-30 mb-lg-0">
                                <div className="price__shape transition-3 p-absolute"></div>
                                <div className="price__inner p-relative">
                                    <p>New Company Registration Plan</p>
                                    <span>Register your company at a premium address without the need for a physical office space.</span>
                                    <div className="price__features mt-20 mb-30">
                                        <b className="d-block mb-10">Ideal for</b>
                                        <ul>
                                            <li><span>New Company Registration Address Proof</span></li>
                                            <li><span>New GST Registration, APOB and PPOB Registration</span></li>
                                            <li><span>Mailing Address for Courier Handling, Address on Website, Google, Business Card, letterhead etc</span></li>
                                        </ul>
                                    </div>
                                    <Link to="/raipur/virtual-office" className="price-btn">Get in Touch</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="price__item p-relative transition-3 fix mb-30 mb-lg-0">
                                <div className="price__shape transition-3 p-absolute"></div>
                                <div className="price__inner p-relative">
                                    <p>GST Registration Plan</p>
                                    <span>Broaden the reach of your current business by venturing into new states across the country.</span>
                                    <div className="price__features mt-20 mb-30">
                                        <b className="d-block mb-10">Ideal for</b>
                                        <ul>
                                            <li><span>New GST Registration</span></li>
                                            <li><span>Principal Place of Business (PPOB) Registration</span></li>
                                            <li><span>Additional Place of Business (APOB) Registration</span></li>
                                            <li><span>Mailing Address for Courier Handling, Address on Website, Google, Business Card, letterhead etc</span></li>
                                        </ul>
                                    </div>
                                    <Link to="/raipur/virtual-office" className="price-btn">Get in Touch</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="price__item p-relative transition-3 fix">
                                <div className="price__shape transition-3 p-absolute"></div>
                                <div className="price__inner p-relative">
                                    <p>Business Address Plan</p>
                                    <span>Secure a professional business address for your company in prime locations.</span>
                                    <div className="price__features mt-20 mb-30">
                                        <b className="d-block mb-10">Ideal for</b>
                                        <ul>
                                            <li><span>Mailing Address for Courier Handling</span></li>
                                            <li><span>Mailing Address on Website</span></li>
                                            <li><span>Business Address Google My Business Page</span></li>
                                            <li><span>Mailing address Business Card, letterhead, Brochure etc</span></li>
                                        </ul>
                                    </div>
                                    <Link to="/raipur/virtual-office" className="price-btn">Get in Touch</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PlanSection;